<template lang="pug">

  div

    v-dialog(v-model="isVisible" max-width="555px" :persistent="loading")

      .dialogHeader

        .dialogHeaderTitle
          | Novo plantão

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="isVisible = false")

      .dialogBody

        //- .dialogBodyContent(v-if="loading" :style="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }")
          v-progress-circular(indeterminate color="red")

        //- .dialogBodyContent(v-else)

        .dialogBodyContent

          .createTurnField.createTurnField--first
            sos-select(:fullscreen="true" fullscreenTitle="Escala" :fullscreenAutoWidth="true" :autoHeight="true" label="Escala" :labelDescription="listeners.loadingGroupScales === 'no' && processedGroupScales.length === 0 ? '(Nota: O grupo não tem escalas)' : ''" :items="selectScales" @sosSelectChanged="onSelectScale" :default="scaleID" :disabled="loading")

          .createTurnField
            label.csLabel
              span(v-html="'Data'")
            .csFields.csFields--date
              date-picker(v-model="dutyDate" :multiple="true" valueType="format" format="DD/MM/YYYY" :lang="lang" @change="onSelectData" class="groupUserField--date" :disabled="loading")

          .createTurnField
            sos-time-select(label="Horário de início" labelDescription="(Entre 00:00 e 23:55)" :hours="allowedHours" :minutes="allowedMinutes" @sosSelectChanged="onSelectTime" :default="dutyTime" :disabled="loading")

          .createTurnField
            sos-time-select(label="Duração" labelDescription="(Entre 30 min e 23h30m)" :hours="selectedDutyDuration.minute === '00' || selectedDutyDuration.minute === '10' || selectedDutyDuration.minute === '20' ? allowedDurationHoursMin : allowedHours" :minutes="((selectedDutyDuration.hour === '00') ? allowedDurationMinutesMin : allowedDurationMinutes)" @sosSelectChanged="onSelectDuration" :default="selectedDutyDuration" :disabled="loading")

          .createTurnField
            sos-select(label="Valor hora desejado" :items="selectBases" @sosSelectChanged="onSelectBase" :default="selectedCalculationBase" :disabled="loading")

          //-
            -
            -
            - Valor previsto do plantão
            -
            -
            -

          .sosProjectionContainer(v-if="selectedDurationMinutes > 0")
            h2.sosProjectionContainer__title
              | Valor previsto do plantão
            .sosProjectionContainer__formulaContainer(v-if="(this.hasTypeWeekOnDates('weekdays') && weekdaysHourlyRate.value === 0) || (this.hasTypeWeekOnDates('weekend') && weekendHourlyRate.value === 0) || selectedCalculationBase !== 'user_scale'")
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Valor hora desejado:' }}
                .sosProjectionContainer__innerValue {{ `${hourlyRate.formatted}&nbsp;` }}
                  b(style="opacity: 0.8; color: cadetblue; font-size: 16px") {{ '(60 min)' }}
              .sosProjectContainer__operator {{ 'X' }}
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Duração selecionada:' }}
                .sosProjectionContainer__innerValue {{ `${selectedDurationMinutes} min` }}

            //- Segunda a Sexta
            .sosProjectionContainer__formulaContainer(v-if="weekdaysHourlyRate.value > 0 && this.hasTypeWeekOnDates('weekdays') && selectedCalculationBase === 'user_scale'")
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Valor hora de seg a sex:' }}
                .sosProjectionContainer__innerValue {{ `${weekdaysHourlyRate.formatted}&nbsp;` }}
                  b(style="opacity: 0.8; color: cadetblue; font-size: 16px") {{ '(60 min)' }}
              .sosProjectContainer__operator {{ 'X' }}
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Duração selecionada:' }}
                .sosProjectionContainer__innerValue {{ `${selectedDurationMinutes} min` }}

            //- Final de semana
            .sosProjectionContainer__formulaContainer(v-if="weekendHourlyRate.value > 0 && this.hasTypeWeekOnDates('weekend') && selectedCalculationBase === 'user_scale'")
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Valor hora FDS:' }}
                .sosProjectionContainer__innerValue {{ `${weekendHourlyRate.formatted}&nbsp;` }}
                  b(style="opacity: 0.8; color: cadetblue; font-size: 16px") {{ '(60 min)' }}

              .sosProjectContainer__operator {{ 'X' }}
              .sosProjectionContainer__innerContainer
                .sosProjectionContainer__innerTitle {{ 'Duração selecionada:' }}
                .sosProjectionContainer__innerValue {{ `${selectedDurationMinutes} min` }}
            .sosProjectionContainer__resultContainer
              span.sosProjectionContainer__result
                span.sosProjectionContainer__result--equal
                  | =&nbsp;
                | {{ dutyCalculatedValueFormatted }}

          //-
            -
            -
            - Ações
            -
            -
            -

          .mt-7.text-right
            sos-button(@buttonClick="createDuty" buttonLabel="Criar plantão" buttonIcon="mdi-plus" buttonIconSize="20" size="medium" color="success" :loading="loading")

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  // Vuex
  import { mapState } from 'vuex'

  import dateTimeLanguage from '@/constants/dateTimeLanguage'

  import { canAddUserShift } from '@/functions'
  import { apiCreateDuty } from '@/services/duties'
  import { durationToMinutes, formatMoney } from '@/mixins/utils'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  import SosTimeSelect from '@/components/SosTimeSelect'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'

  import moment, { weekdays } from 'moment'
  import 'moment/locale/pt-br'
  moment.locale('pt-BR')

  export default {
    name: 'NewUserDutyModal',

    components: {
      'sos-select': SosSelect,
      'sos-time-select': SosTimeSelect,
      'sos-button': SosButton,
      'date-picker': DatePicker,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        isVisible: false,
        loading: false,

        // --- BASE DO CÁLCULO DO VALOR DO PLANTÃO
        selectedCalculationBase: 'user_scale',

        // --- VALOR HORA DO USUÁRIO (GRUPO)
        userGroupHourlyRate: 0,
        userGroupHourlyRateFormatted: 'R$ 0,00',

        // --- VALOR HORA DO USUÁRIO (ESCALA SELECIONADA)
        userSelectedScaleHourlyRate: 0,
        userSelectedScaleHourlyRateFormatted: 'R$ 0,00',

        // Valor hora geral do usuário
        // userSelectedScaleGeneralHourlyRate: 0,
        // userSelectedScaleGeneralHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta
        userSelectedScaleWeekdaysHourlyRate: 0,
        userSelectedScaleWeekdaysHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana
        userSelectedScaleWeekendHourlyRate: 0,
        userSelectedScaleWeekendHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário (diurno)
        userSelectedScaleDayShiftHourlyRate: 0,
        userSelectedScaleDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário (noturno)
        userSelectedScaleNightShiftHourlyRate: 0,
        userSelectedScaleNightShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta (diurno)
        userSelectedScaleWeekdaysDayShiftHourlyRate: 0,
        userSelectedScaleWeekdaysDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta (noturno)
        userSelectedScaleWeekdaysNightShiftHourlyRate: 0,
        userSelectedScaleWeekdaysNightShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana (diurno)
        userSelectedScaleWeekendDayShiftHourlyRate: 0,
        userSelectedScaleWeekendDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana (noturno)
        userSelectedScaleWeekendNightShiftHourlyRate: 0,
        userSelectedScaleWeekendNightShiftHourlyRateFormatted: 'R$ 0,00',

        // --- MÊS/ANO SELECIONADO/CARREGADO
        selectedMonth: null,
        selectedYear: null,

        // --- Escala
        scaleID: '',

        // --- Valor da escala
        scaleValue: 0,
        scaleValueFormatted: 'R$ 0,00',

        // --- Data
        dutyDate: [],

        // --- Hora início
        dutyTime: { hour: '', minute: '00' },

        // --- Duração
        selectedDutyDuration: { hour: '', minute: '00' },

        // --- Nome do turno
        shiftName: '',

        // --- Valor calculado
        selectedDurationMinutes: 0,
        dutyCalculatedValue: 0, // VALOR DA ESCALA (POR HORA) * DURAÇÃO DO PLANTÃO
        dutyCalculatedValueFormatted: 'R$ 0,00',

        // --- Valor calculado sem prioridade
        dutyCalculatedValueNoPriority: 0,
        dutyCalculatedValueNoPriorityFormatted: 'R$ 0,00',

        // --- Valor calculado dias de semana
        dutyWeekdaysCalculatedValue: 0,
        dutyWeekdaysCalculatedValueFormatted: 'R$ 0,00',

        // --- Valor calculado final de semana
        dutyWeekendCalculatedValue: 0,
        dutyWeekendCalculatedValueFormatted: 'R$ 0,00',

        // --- Allowed
        allowedHours: [{ key: '00', text: '00', value: '00' }, { key: '01', text: '01', value: '01' }, { key: '02', text: '02', value: '02' }, { key: '03', text: '03', value: '03' }, { key: '04', text: '04', value: '04' }, { key: '05', text: '05', value: '05' }, { key: '06', text: '06', value: '06' }, { key: '07', text: '07', value: '07' }, { key: '08', text: '08', value: '08' }, { key: '09', text: '09', value: '09' }, { key: '10', text: '10', value: '10' }, { key: '11', text: '11', value: '11' }, { key: '12', text: '12', value: '12' }, { key: '13', text: '13', value: '13' }, { key: '14', text: '14', value: '14' }, { key: '15', text: '15', value: '15' }, { key: '16', text: '16', value: '16' }, { key: '17', text: '17', value: '17' }, { key: '18', text: '18', value: '18' }, { key: '19', text: '19', value: '19' }, { key: '20', text: '20', value: '20' }, { key: '21', text: '21', value: '21' }, { key: '22', text: '22', value: '22' }, { key: '23', text: '23', value: '23' }],
        allowedMinutes: [{ key: '00', text: '00', value: '00' }, { key: '05', text: '05', value: '05' }, { key: '10', text: '10', value: '10' }, { key: '15', text: '15', value: '15' }, { key: '20', text: '20', value: '20' }, { key: '25', text: '25', value: '25' }, { key: '30', text: '30', value: '30' }, { key: '35', text: '35', value: '35' }, { key: '40', text: '40', value: '40' }, { key: '45', text: '45', value: '45' }, { key: '50', text: '50', value: '50' }, { key: '55', text: '55', value: '55' }],
        allowedDurationHoursMin: [{ key: '01', text: '01', value: '01' }, { key: '02', text: '02', value: '02' }, { key: '03', text: '03', value: '03' }, { key: '04', text: '04', value: '04' }, { key: '05', text: '05', value: '05' }, { key: '06', text: '06', value: '06' }, { key: '07', text: '07', value: '07' }, { key: '08', text: '08', value: '08' }, { key: '09', text: '09', value: '09' }, { key: '10', text: '10', value: '10' }, { key: '11', text: '11', value: '11' }, { key: '12', text: '12', value: '12' }, { key: '13', text: '13', value: '13' }, { key: '14', text: '14', value: '14' }, { key: '15', text: '15', value: '15' }, { key: '16', text: '16', value: '16' }, { key: '17', text: '17', value: '17' }, { key: '18', text: '18', value: '18' }, { key: '19', text: '19', value: '19' }, { key: '20', text: '20', value: '20' }, { key: '21', text: '21', value: '21' }, { key: '22', text: '22', value: '22' }, { key: '23', text: '23', value: '23' }],
        allowedDurationMinutesMin: [{ key: '30', text: '30', value: '30' }],
        allowedDurationMinutes: [{ key: '00', text: '00', value: '00' }, { key: '30', text: '30', value: '30' }],

        selectBases: [
          { key: 'base_scale', value: 'scale', text: 'Valor hora da escala selecionada' },
          { key: 'base_user_scale', value: 'user_scale', text: 'Valor hora do usuário na escala selecionada' },
          { key: 'base_user_group', value: 'user_group', text: 'Valor hora do usuário no grupo' },
        ],

        lang: dateTimeLanguage,
      }
    },

    computed: {
      ...mapState({
        listeners: state => state.app.listeners,
        groupScales: state => state.app.groupScales,
      }),

      processedGroupScales () {
        return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
      },

      selectScales ()
      {
        if (this.processedGroupScales.length === 0) return []

        const userID = this.$route.params.userID

        // ESCALAS DE CADA USUÁRIO DO GRUPO
        const userScales = this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(relatedUserID => relatedUserID === userID)).map(gs => gs.scaleID)

        return this.processedGroupScales.filter(s => {
          return (
            // Usuário relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
            userScales.length === 0 ||
            (
              // Usuário encontrado + Relacionado a escala do plantão a ser dividido
              userScales.length > 0 &&
              userScales.some(scaleID => scaleID === s.scaleID)
            )
          )
        }).map(s => {
          const userSelectedScaleHasHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].hourlyrate === true
          const userSelectedScaleHourlyRate = userSelectedScaleHasHourlyRate ? s.scaleUsers[userID].hourlyrate : 0
          const userSelectedScaleHourlyRateFormatted = formatMoney(userSelectedScaleHourlyRate)

          return {
            key: `scale_${s.scaleID}`,
            value: s.scaleID,
            text: `<span class="journeyOption">${s.scaleName}<br />` + (
              `<span class="journeyOptionObservation"><span class="journeyBold">Valor hora</span>: ${s.scaleValueFormatted} <i class="journeyGray">(Escala)</i> ou ${userSelectedScaleHourlyRateFormatted} <i class="journeyGray">(Usuário na escala)</i></span></span>`
            ),
          }
        })
      },

      // Definindo periodo baseado na hora
      periodName() {
        return this.dutyTime.hour >= 17 ? 'night' : 'day'
      },

      // Resolvendo valor hora de final de semana
      weekendHourlyRate() {
        return this.resolveHourlyRateHierarchy('weekend', this.periodName)
      },

      // Resolvendo valor hora dia de semana
      weekdaysHourlyRate() {
        return this.resolveHourlyRateHierarchy('weekdays', this.periodName)
      },

      hourlyRate() {
        if (this.selectedCalculationBase === 'scale') return this.resolveHourlyRateHierarchy('default', this.periodName, 'scaleValue')
        if (this.selectedCalculationBase === 'user_scale') return this.resolveHourlyRateHierarchy('default', this.periodName)
        if (this.selectedCalculationBase === 'user_group') return this.resolveHourlyRateHierarchy('default', this.periodName, 'userGroupHourlyRate')
      },
    },

    watch: {
      '$store.state.app.groupScales': function ()
      {
        const defaultScale = !!this.$store.state.app.groupScales === true && this.$store.state.app.groupScales.length > 0 ? this.$store.state.app.groupScales[0] : null

        if (!!defaultScale === true) this.setScale(defaultScale)
      },
    },

    /* created () {
      // [24/01/25] console.log('::: [NewUserDutyModal] created - groupID:', this.$route.params.groupID)
      // [24/01/25] console.log('::: [NewUserDutyModal] created - userID:', this.$route.params.userID)
    }, */

    mounted () {
      // [24/01/25] console.log('::: [NewUserDutyModal] - mounted')

      this.dutyDate = [moment().format('DD/MM/YYYY')]

      //
      // CORREÇÃO: LÊ ALGUNS DADOS DA ESCALA QUANDO O USUÁRIO SAI DA TELA "PLANTÕES DO USUÁRIO" E VOLTA
      //

      const defaultScale = !!this.$store.state.app.groupScales === true && this.$store.state.app.groupScales.length > 0 ? this.$store.state.app.groupScales[0] : null

      if (!!defaultScale === true) this.setScale(defaultScale)
    },

    /* beforeDestroy () {
      // [24/01/25] console.log('::: [NewUserDutyModal] - beforeDestroy')
    }, */

    methods: {
      //
      //
      //

      open (selectedYear, selectedMonth, userGroupHourlyRate)
      {
        this.selectedYear = selectedYear
        this.selectedMonth = selectedMonth

        // this.selectedCalculationBase = 'scale'

        this.userGroupHourlyRate = userGroupHourlyRate
        this.userGroupHourlyRateFormatted = formatMoney(userGroupHourlyRate)

        this.isVisible = true

        // [24/01/25] console.log('::: [DIALOG] NEW "USER SHIFT":', this.selectedYear, this.selectedMonth)
      },

      //
      //
      //

      cdAction (cdResponse)
      {
        // [24/01/25] console.log('::: NewUserDutyModal -> cdAction:', cdResponse)

        if (cdResponse === false) return false

        const type = cdResponse.cdType
        // const data = cdResponse.cdData

        if (type === 'addUser')
        {
          this.createDuty(false)
        }
      },

      //
      // CRIAR PLANTÃO DO USUÁRIO
      //

      async createDuty (validateConflicts = true)
      {
        if (this.loading) return false

        const { groupID = '', userID = '' } = this.$route.params

        const {
          scaleID = '',
          dutyDate = [],
          dutyTime = {
            hour: '',
            minute: '00',
          },
          selectedDutyDuration = { hour: '', minute: '00' },
        } = this

        const validDates = Array.isArray(dutyDate) && dutyDate.length > 0 ? dutyDate.filter(date => /^\d{2}[./-]\d{2}[./-]\d{4}$/.test(date)) : []

        const e = []

        if (scaleID.length === 0) e.push('Selecione uma escala!')
        if (validDates.length === 0) e.push('Selecione uma data!')
        if (validDates.length > 31) e.push('Selecione no máximo 31 dias!')
        if (dutyTime.hour.length === 0 || dutyTime.minute.length === 0) e.push('Selecione o horário de início!')
        if (selectedDutyDuration.hour.length === 0 || selectedDutyDuration.minute.length === 0) e.push('Selecione a duração!')
        if (this.dutyCalculatedValue < 0) e.push('Informe um valor positivo!')

        if (e.length > 0) return this.showMessage('Atenção!', e.join('<br>'))

        this.loading = true

        //
        // Dados do plantão
        //

        const dutyStartTime = `${dutyTime.hour}:${dutyTime.minute}`

        //
        // CONFLITOS
        //

        if (validateConflicts)
        {
          const selectedYear = Number(this.selectedYear)
          const selectedMonth = Number(this.selectedMonth) - 1

          const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
          const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

          // [24/01/25] console.log('::: selectedYear, selectedMonth:', selectedYear, selectedMonth)
          // [24/01/25] console.log('::: firstDate:', firstDate.format('YYYY-MM-DD HH:mm:ss'))
          // [24/01/25] console.log('::: lastDate:', lastDate.format('YYYY-MM-DD HH:mm:ss'))

          //
          // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
          //

          const { conflictedScales = [], conflictsTableHtml = '' } = await canAddUserShift(dutyStartTime, validDates, userID, firstDate, lastDate)

          if (conflictedScales.length > 0)
          {
            this.loading = false

            return this.showConfirmBox({
              title: 'Conflito!',
              text: `<div style="text-align: center">O usuário já tem algum plantão ${validDates.length === 1 ? 'na data' : 'nas datas'} e no horário que você selecionou.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
              type: 'addUser',
              data: '',
              isResponse: false,
              buttonPosition: 'right',
              width: 330,
              closeText: 'Não',
              continueText: 'Sim',
            })
          }
        }

        //
        // Dados do plantão
        //

        const dutyDuration = selectedDutyDuration.minute === '00' ? parseInt(selectedDutyDuration.hour) : `${selectedDutyDuration.hour}:${selectedDutyDuration.minute}`

        const scale = this.groupScales.find(scaleItem => scaleItem.scaleID === scaleID)
        const dutyName = !!scale === true ? scale.scaleName : ''
        const dutyLocal = !!scale === true ? scale.scaleLocation.name : ''

        const p = validDates.map(date => {
          // dutyStartDate
          const selectedDutyStartDate = moment.utc(date, 'DD/MM/YYYY')
          const dataInicioFmt = selectedDutyStartDate.format('YYYY-M-D')
          const dutyStartDate = selectedDutyStartDate.unix() * 1000
          let dutyValue = 0

          // Se a base de cálculo for usuário na escala, usa a estimativa de valor do plantão de acordo com o tipo de semana
          if (this.typeWeek(date) === 'weekdays' && this.dutyWeekdaysCalculatedValue > 0 && this.selectedCalculationBase === 'user_scale') {
            dutyValue = this.dutyWeekdaysCalculatedValue
          } else if (this.typeWeek(date) === 'weekend' && this.dutyWeekendCalculatedValue > 0 && this.selectedCalculationBase === 'user_scale') {
            dutyValue = this.dutyWeekendCalculatedValue
          } else if (this.dutyNoPriorityCalculatedValue > 0 && this.selectedCalculationBase === 'user_scale') {
            dutyValue = this.dutyNoPriorityCalculatedValue
          }

          // Se a base de cálculo for escala ou valor hora do grupo, usa a estimativa de valor do plantão
          if (this.selectedCalculationBase === 'scale' || this.selectedCalculationBase === 'user_group') {
            dutyValue = this.dutyCalculatedValue
          }

          // dutyStartDate

          return {
            dutyGroupID: groupID,
            dutyScaleID: scaleID,
            dutyOwnerID: userID,

            dutyMessageDate: date,
            dataInicioFmt,

            dutyStartDate,
            dutyStartTime,
            dutyDuration,

            dutyName,
            dutyLocal,

            dutyValue,
          }
        })

        // [24/01/25] console.log('::: CREATE DUTY:', p)

        //
        // RUN DATABASE INSERTION
        //

        apiCreateDuty(p, response => {
          // [24/01/25] console.log('::: apiCreateDuty:', response)

          this.loading = false

          if (response.code === 0) {
            this.showMessage('Erro', 'Desculpe, não foi possível criar o plantão. Por favor, entre em contato com o suporte técnico.')
          } else {
            this.isVisible = false
            this.showMessage('Sistema', 'Os plantões foram criados!')
          }
        })
      },

       /**
       * Verifica se existe algum dia de final de semana ou dia de semana nas datas do plantão
       * @param typeWeek = 'weekend' ou 'weekdays'
       */
       hasTypeWeekOnDates(typeWeek) {
        if (!this.dutyDate || this.dutyDate.length === 0) return false;

        return this.dutyDate.some(dateStr => {
          const date = moment(dateStr, "DD/MM/YYYY");
          const dayOfWeek = date.day(); // 0 = Domingo, 6 = Sábado

          if (typeWeek === 'weekend') {
            return dayOfWeek === 0 || dayOfWeek === 6;
          }

          if (typeWeek === 'weekdays') {
            return dayOfWeek >= 1 && dayOfWeek <= 5; // Segunda (1) a Sexta (5)
          }
        });
      },

      // Verifica se a data informada é final de semana ou dia de semana
      typeWeek(dateStr = '29/04/2025') {
        if (!this.dutyDate || this.dutyDate.length === 0) return false;

        const date = moment(dateStr, "DD/MM/YYYY");
        const dayOfWeek = date.day(); // 0 = Domingo, 6 = Sábado

        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return 'weekend';
        }

        if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Segunda (1) a Sexta (5)
          return 'weekdays';
        }
      },

      /**
       * Resolve a hierarquia de valores de acordo com o tipo de semana (final de semana ou dia de semana)
       * @param typeWeek = 'weekdays' ou 'weekend'
       * @param period = 'day', 'night' ou 'both'
       * @param findBy = 'none' ou 'key' - Se for 'key', retorna o objeto do valor hora da key informado
       */
      resolveHourlyRateHierarchy(typeWeek = '', period = '', findByKey = null) {
        // Hierarquia de valores horas restantes que não está vinculado ao usuário (sem prioridade)
        const noPriorityHourlyRates = {
          scaleValue: {
            key: 'scaleValue',
            value: this.scaleValue,
            formatted: this.scaleValueFormatted,
            period: 'both',
            ignoreWeek: true
          },
          userGroupHourlyRate: {
            key: 'userGroupHourlyRate',
            value: this.userGroupHourlyRate,
            formatted: this.userGroupHourlyRateFormatted,
            period: 'both',
            ignoreWeek: true
          },
        }

        // Hierarquia de valores horas restantes do usuário (sem prioridade)
        const userNoPriorityHourlyRates = {
          userSelectedScaleNightShiftHourlyRate: {
            key: 'userSelectedScaleNightShiftHourlyRate',
            value: this.userSelectedScaleNightShiftHourlyRate,
            formatted: this.userSelectedScaleNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleDayShiftHourlyRate: {
            key: 'userSelectedScaleDayShiftHourlyRate',
            value: this.userSelectedScaleDayShiftHourlyRate,
            formatted: this.userSelectedScaleDayShiftHourlyRateFormatted,
            period: 'day'
          },
          // userSelectedScaleGeneralHourlyRate: {
          //   key: 'userSelectedScaleGeneralHourlyRate',
          //   value: this.userSelectedScaleGeneralHourlyRate,
          //   formatted: this.userSelectedScaleGeneralHourlyRateFormatted,
          //   period: 'both'
          // },
          userSelectedScaleHourlyRate: {
            key: 'userSelectedScaleHourlyRate',
            value: this.userSelectedScaleHourlyRate,
            formatted: this.userSelectedScaleHourlyRateFormatted,
            period: 'both'
          },
        }

        // Hierarquia de valores horas para dia de semana
        const userWeekdaysHourlyRates = {
          userSelectedScaleWeekdaysNightShiftHourlyRate: {
            key: 'userSelectedScaleWeekdaysNightShiftHourlyRate',
            value: this.userSelectedScaleWeekdaysNightShiftHourlyRate,
            formatted: this.userSelectedScaleWeekdaysNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleWeekdaysDayShiftHourlyRate: {
            key: 'userSelectedScaleWeekdaysDayShiftHourlyRate',
            value: this.userSelectedScaleWeekdaysDayShiftHourlyRate,
            formatted: this.userSelectedScaleWeekdaysDayShiftHourlyRateFormatted,
            period: 'day'
          },
          userSelectedScaleWeekdaysHourlyRate: {
            key: 'userSelectedScaleWeekdaysHourlyRate',
            value: this.userSelectedScaleWeekdaysHourlyRate,
            formatted: this.userSelectedScaleWeekdaysHourlyRateFormatted,
            period: 'both'
          },

          // ...userNoPriorityHourlyRates
        }

        // Hierarquia de valores horas para final de semana
        const userWeekendHourlyRates = {
          userSelectedScaleWeekendNightShiftHourlyRate: {
            key: 'userSelectedScaleWeekendNightShiftHourlyRate',
            value: this.userSelectedScaleWeekendNightShiftHourlyRate,
            formatted: this.userSelectedScaleWeekendNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleWeekendDayShiftHourlyRate: {
            key: 'userSelectedScaleWeekendDayShiftHourlyRate',
            value: this.userSelectedScaleWeekendDayShiftHourlyRate,
            formatted: this.userSelectedScaleWeekendDayShiftHourlyRateFormatted,
            period: 'day'
          },
          userSelectedScaleWeekendHourlyRate: {
            key: 'userSelectedScaleWeekendHourlyRate',
            value: this.userSelectedScaleWeekendHourlyRate,
            formatted: this.userSelectedScaleWeekendHourlyRateFormatted,
            period: 'both'
          },

          // ...userNoPriorityHourlyRates
        }

        const allHourlyRates = {
          ...userWeekdaysHourlyRates,
          ...userWeekendHourlyRates,
          ...userNoPriorityHourlyRates,
          ...noPriorityHourlyRates
        }

        // Encontra o valor hora específico da key informada
        if (findByKey) return allHourlyRates[findByKey]

        // Percorre as hierarquias de valores de acordo com o tipo de semana (final de semana ou dia de semana)
        switch (typeWeek) {
          case 'weekdays': {
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userWeekdaysHourlyRates
            })
          }
          case 'weekend': {
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userWeekendHourlyRates
            })
          }
          default:
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userNoPriorityHourlyRates
            })
        }
      },

      /**
       * Encontra a regra de acordo com a prioridade (onde o primeiro valor do objeto é prioridade 1, o segundo valor é prioridade 2, etc)
       * @param props = {
       *  period: '', // 'day', 'night', 'both'
       *  hierarchyRules: []
       * }
       */
      findRuleByPriorityHierarchy(props = {
        period: '', // 'day', 'night', 'both'
        hierarchyRules: []
      }) {
        let result = null

        const found = Object.entries(props.hierarchyRules).find(([key, obj]) => {
          // const isIgnoreOnWeek = obj.ignoreWeek === true
          const isPeriodSelected = obj.value > 0 && obj.period === props.period
          const isBothPeriods = obj.value > 0 && obj.period === 'both';

          if (isPeriodSelected || isBothPeriods) {
            return obj
          }
        });

        if (found) result = found[1];

        // Se não encontrou, retorna um objeto zerado
        if (result === null) {
          result = {
            key: null,
            value: 0,
            formatted: 'R$ 0,00',
            period: null
          }
        }

        return result
      },

      //
      // EVENT HANDLING FOR EACH SELECT COMPONENT
      //

      onSelectScale (scaleID)
      {
        const scale = this.groupScales.length > 0 ? this.groupScales.find(scaleItem => scaleItem.scaleID === scaleID) : false

        // [24/01/25] console.log('::: onSelectScale:', scaleID, scale)

        if (!!scale === false) return false

        this.setScale(scale)
      },

      onSelectData (date)
      {
        this.calculate(`${this.selectedDutyDuration.hour}:${this.selectedDutyDuration.minute}`)
      },

      onSelectTime (time)
      {
        this.dutyTime = time
        this.calculate(`${this.selectedDutyDuration.hour}:${this.selectedDutyDuration.minute}`)
        // [24/01/25] console.log('::: [NewUserDutyModal] USER SELECTED TIME:', time.hour, time.minute)
      },

      onSelectDuration (duration)
      {
        this.selectedDutyDuration = duration
        // this.selectedDurationMinutes = durationToMinutes(`${duration.hour}:${duration.minute}`)

        // Calcula o valor do plantão baseado no VALOR BASE SELECIONADO e outros parâmetros
        this.calculate(`${duration.hour}:${duration.minute}`)
      },

      onSelectBase (base)
      {
        this.selectedCalculationBase = base

        // Calcula o valor do plantão baseado no VALOR BASE SELECIONADO e outros parâmetros
        this.calculate(`${this.selectedDutyDuration.hour}:${this.selectedDutyDuration.minute}`)
      },

      //
      //
      //

      setScale (s) {
        this.scaleID = s.scaleID
        this.scaleValue = s.scaleValue
        this.scaleValueFormatted = s.scaleValueFormatted

        // console.log('this.dutyDate:', this.dutyDate);


        // Valor hora do plantonista dentro da escala selecionada
        const userID = this.$route.params.userID

        // Valor hora do usuário na escala
        const userSelectedScaleHasHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].hourlyrate === true
        const userSelectedScaleHourlyRate = userSelectedScaleHasHourlyRate ? s.scaleUsers[userID].hourlyrate : 0
        this.userSelectedScaleHourlyRate = userSelectedScaleHourlyRate
        this.userSelectedScaleHourlyRateFormatted = formatMoney(userSelectedScaleHourlyRate)

        // Valor hora geral do usuário
        // const userSelectedScaleHasGeneralHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].generalHourlyRate === true
        // const userSelectedScaleGeneralHourlyRate = userSelectedScaleHasGeneralHourlyRate ? s.scaleUsers[userID].generalHourlyRate : 0
        // this.userSelectedScaleGeneralHourlyRate = userSelectedScaleGeneralHourlyRate
        // this.userSelectedScaleGeneralHourlyRateFormatted = formatMoney(userSelectedScaleGeneralHourlyRate)

        // Valor hora do usuário de segunda a sexta
        const userSelectedScaleHasWeekdaysHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysHourlyRate === true
        const userSelectedScaleWeekdaysHourlyRate = userSelectedScaleHasWeekdaysHourlyRate ? s.scaleUsers[userID].weekdaysHourlyRate : 0
        this.userSelectedScaleWeekdaysHourlyRate = userSelectedScaleWeekdaysHourlyRate
        this.userSelectedScaleWeekdaysHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysHourlyRate)

        // Valor hora do usuário de final de semana
        const userSelectedScaleHasWeekendHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendHourlyRate === true
        const userSelectedScaleWeekendHourlyRate = userSelectedScaleHasWeekendHourlyRate ? s.scaleUsers[userID].weekendHourlyRate : 0
        this.userSelectedScaleWeekendHourlyRate = userSelectedScaleWeekendHourlyRate
        this.userSelectedScaleWeekendHourlyRateFormatted = formatMoney(userSelectedScaleWeekendHourlyRate)

        // Valor hora do usuário (diurno)
        const userSelectedScaleHasDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].dayShiftHourlyRate === true
        const userSelectedScaleDayShiftHourlyRate = userSelectedScaleHasDayShiftHourlyRate ? s.scaleUsers[userID].dayShiftHourlyRate : 0
        this.userSelectedScaleDayShiftHourlyRate = userSelectedScaleDayShiftHourlyRate
        this.userSelectedScaleDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleDayShiftHourlyRate)

        // Valor hora do usuário (noturno)
        const userSelectedScaleHasNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].nightShiftHourlyRate === true
        const userSelectedScaleNightShiftHourlyRate = userSelectedScaleHasNightShiftHourlyRate ? s.scaleUsers[userID].nightShiftHourlyRate : 0
        this.userSelectedScaleNightShiftHourlyRate = userSelectedScaleNightShiftHourlyRate
        this.userSelectedScaleNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleNightShiftHourlyRate)

        // Valor hora do usuário de segunda a sexta (diurno)
        const userSelectedScaleHasWeekdaysDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysDayShiftHourlyRate === true
        const userSelectedScaleWeekdaysDayShiftHourlyRate = userSelectedScaleHasWeekdaysDayShiftHourlyRate ? s.scaleUsers[userID].weekdaysDayShiftHourlyRate : 0
        this.userSelectedScaleWeekdaysDayShiftHourlyRate = userSelectedScaleWeekdaysDayShiftHourlyRate
        this.userSelectedScaleWeekdaysDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysDayShiftHourlyRate)

        // Valor hora do usuário de segunda a sexta (noturno)
        const userSelectedScaleHasWeekdaysNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysNightShiftHourlyRate === true
        const userSelectedScaleWeekdaysNightShiftHourlyRate = userSelectedScaleHasWeekdaysNightShiftHourlyRate ? s.scaleUsers[userID].weekdaysNightShiftHourlyRate : 0
        this.userSelectedScaleWeekdaysNightShiftHourlyRate = userSelectedScaleWeekdaysNightShiftHourlyRate
        this.userSelectedScaleWeekdaysNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysNightShiftHourlyRate)

        // Valor hora do usuário de final de semana (diurno)
        const userSelectedScaleHasWeekendDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendDayShiftHourlyRate === true
        const userSelectedScaleWeekendDayShiftHourlyRate = userSelectedScaleHasWeekendDayShiftHourlyRate ? s.scaleUsers[userID].weekendDayShiftHourlyRate : 0
        this.userSelectedScaleWeekendDayShiftHourlyRate = userSelectedScaleWeekendDayShiftHourlyRate
        this.userSelectedScaleWeekendDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekendDayShiftHourlyRate)

        // Valor hora do usuário de final de semana (noturno)
        const userSelectedScaleHasWeekendNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendNightShiftHourlyRate === true
        const userSelectedScaleWeekendNightShiftHourlyRate = userSelectedScaleHasWeekendNightShiftHourlyRate ? s.scaleUsers[userID].weekendNightShiftHourlyRate : 0
        this.userSelectedScaleWeekendNightShiftHourlyRate = userSelectedScaleWeekendNightShiftHourlyRate
        this.userSelectedScaleWeekendNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekendNightShiftHourlyRate)

        // Calcula o valor do plantão baseado no VALOR BASE SELECIONADO e outros parâmetros
        if (!!this.selectedDutyDuration === true && !!this.selectedDutyDuration.hour === true && !!this.selectedDutyDuration.minute === true) {
          this.calculate(`${this.selectedDutyDuration.hour}:${this.selectedDutyDuration.minute}`)
        }
      },

      //
      // Calcula o valor do plantão baseado no VALOR BASE SELECIONADO e outros parâmetros
      //

      calculate (duration) {
        if (String(duration).length !== 5) return false

        let weekdaysHourlyRate = 0;
        let weekendHourlyRate = 0;
        let noPriorityHourlyRate = 0;
        const hourlyRatesSelected = {
          scale: this.resolveHourlyRateHierarchy('default', this.periodName, 'scaleValue').value,
          user_group: this.resolveHourlyRateHierarchy('default', this.periodName, 'userGroupHourlyRate').value
        }

        if (this.hasTypeWeekOnDates('weekdays') && this.weekdaysHourlyRate.value > 0) weekdaysHourlyRate = this.weekdaysHourlyRate.value
        if (this.hasTypeWeekOnDates('weekend') && this.weekendHourlyRate.value > 0) weekendHourlyRate = this.weekendHourlyRate.value
        if (this.hourlyRate.value > 0 && (this.weekdaysHourlyRate.value === 0 || this.weekendHourlyRate.value === 0)) noPriorityHourlyRate = this.hourlyRate.value

        const hourlyRate = hourlyRatesSelected[this.selectedCalculationBase] ?? 0

        this.selectedDurationMinutes = durationToMinutes(`${duration}`)

        // Calcula os valores do plantão baseado nos valores de cada hierarquia
        const dutyWeekdaysCalculatedValue = weekdaysHourlyRate > 0 && this.selectedDurationMinutes > 0 && this.selectedCalculationBase === 'user_scale' ? (this.selectedDurationMinutes / 60) * weekdaysHourlyRate : 0
        const dutyWeekendCalculatedValue = weekendHourlyRate > 0 && this.selectedDurationMinutes > 0 && this.selectedCalculationBase === 'user_scale' ? (this.selectedDurationMinutes / 60) * weekendHourlyRate : 0
        const dutyNoPriorityCalculatedValue = noPriorityHourlyRate > 0 && this.selectedDurationMinutes > 0 && (this.hasTypeWeekOnDates('weekdays') || this.hasTypeWeekOnDates('weekend')) && this.selectedCalculationBase === 'user_scale' ? (this.selectedDurationMinutes / 60) * noPriorityHourlyRate : 0
        const dutyCalculatedValueSelected = hourlyRate > 0 && this.selectedDurationMinutes > 0 ? (this.selectedDurationMinutes / 60) * hourlyRate : 0
        const dutyCalculatedValue = dutyWeekdaysCalculatedValue + dutyWeekendCalculatedValue + dutyNoPriorityCalculatedValue + dutyCalculatedValueSelected

        // Atualiza as estimativas dos valores do plantão
        this.dutyCalculatedValue = dutyCalculatedValue
        this.dutyWeekdaysCalculatedValue = dutyWeekdaysCalculatedValue
        this.dutyWeekendCalculatedValue = dutyWeekendCalculatedValue
        this.dutyNoPriorityCalculatedValue = dutyNoPriorityCalculatedValue
        this.dutyCalculatedValueFormatted = formatMoney(dutyCalculatedValue)
      },
    },
  }

</script>

<style lang="scss" scoped>

  .groupUserField--date {
    width: 100%;
  }

  //
  //
  //

  .sosProjectionContainer {
    margin-top: 20px;
    border-radius: 7px;
    border: 2px solid rgba(0, 0, 0, 0.3);

    text-align: center;
  }

  .sosProjectionContainer__title {
    padding: 7px 10px;
    background-color: cadetblue;

    color: lavenderblush;
    font-size: 24px;
  }

  .sosProjectionContainer__formulaContainer {
    position: relative;
    padding: 15px 10px;
    border-bottom: 2px solid #CCCCCC;
  }

  .sosProjectionContainer__innerContainer {
    display: inline-block;
    vertical-align: middle;
    width: 50%;
  }

  .sosProjectionContainer__innerTitle {
    color: black;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
  }

  .sosProjectionContainer__innerValue {
    margin-top: 8px;

    color: steelblue;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }

  .sosProjectContainer__operator {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    width: 28px;
    height: 28px;
    margin: auto;

    color: tomato;
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
  }

  .sosProjectionContainer__resultContainer {
    padding: 15px 10px;
  }

  .sosProjectionContainer__result {
    color: saddlebrown;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
  }

  .sosProjectionContainer__result--equal {
    color: tomato
  }

</style>
